import React, { useState, useEffect } from "react";
import HeaderDriven from "./headerDriven";
import ScrollToTop from "../common/ScrollToTop";
import Drivenprofile from "./drivenprofile";
import { getDrivenlists } from "../../services/wms";

const RenderDrivenprofile = () => {
  const [showonscroll, setshowonscroll] = useState(false);


  const scrollToTop = () => {
    setshowonscroll(false);
  };

  

  return (
    <div className="container-fluid">
      <HeaderDriven />
      <Drivenprofile />

      <ScrollToTop onClick={scrollToTop} />
    </div>
  );
};

export default RenderDrivenprofile;
